import React from 'react';

export const PrivacyPolicyPage = () => {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4 bg-white text-black dark:bg-gray-800 dark:text-white">
      <div className="bg-brand-surface rounded-xl border border-brand-border p-8">
        <h1 className="text-3xl font-bold text-brand-text-primary mb-6">Privacy Policy</h1>
        
        <div className="space-y-6 text-brand-text-primary">
          <section>
            <p className="text-sm text-brand-text-secondary mb-4">
              <strong>Effective Date:</strong> {new Date().toLocaleDateString()}
            </p>
            <p className="mb-4">
              TestSeries ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our exam preparation platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">1. Information We Collect</h2>
            <div className="space-y-3">
              <div>
                <h3 className="font-medium mb-2">Personal Information:</h3>
                <ul className="list-disc pl-6 space-y-1 text-brand-text-secondary">
                  <li>Name, email address, phone number</li>
                  <li>Educational background and exam preferences</li>
                  <li>Account credentials and profile information</li>
                </ul>
              </div>
              <div>
                <h3 className="font-medium mb-2">Usage Data:</h3>
                <ul className="list-disc pl-6 space-y-1 text-brand-text-secondary">
                  <li>Test scores, performance analytics, and progress tracking</li>
                  <li>Device information, IP address, browser type</li>
                  <li>Pages visited, time spent, and interaction patterns</li>
                </ul>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">2. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-2 text-brand-text-secondary">
              <li>Provide and maintain our exam preparation services</li>
              <li>Personalize your learning experience and track progress</li>
              <li>Send important updates about your account and our services</li>
              <li>Improve our platform through analytics and user feedback</li>
              <li>Ensure platform security and prevent fraudulent activities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">3. Information Sharing</h2>
            <p className="mb-3">We do not sell, trade, or rent your personal information. We may share information only in these circumstances:</p>
            <ul className="list-disc pl-6 space-y-2 text-brand-text-secondary">
              <li><strong>Service Providers:</strong> Third-party services that help us operate our platform (hosting, analytics, email services)</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
              <li><strong>Business Transfers:</strong> In connection with mergers, acquisitions, or asset sales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">4. Cookies and Tracking</h2>
            <p className="mb-3">We use cookies and similar technologies to:</p>
            <ul className="list-disc pl-6 space-y-2 text-brand-text-secondary">
              <li>Remember your preferences and login status</li>
              <li>Analyze site traffic and user behavior</li>
              <li>Provide personalized content and advertisements</li>
              <li>Improve site functionality and user experience</li>
            </ul>
            <p className="mt-3 text-brand-text-secondary">
              You can control cookie preferences through your browser settings or our cookie consent banner.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">5. Data Security</h2>
            <p className="text-brand-text-secondary">
              We implement appropriate security measures to protect your information against unauthorized access, alteration, disclosure, or destruction. However, no internet transmission is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">6. Your Rights</h2>
            <p className="mb-3">You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2 text-brand-text-secondary">
              <li>Access, update, or delete your personal information</li>
              <li>Opt-out of marketing communications</li>
              <li>Request data portability or restriction of processing</li>
              <li>Withdraw consent for data processing</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">7. Children's Privacy</h2>
            <p className="text-brand-text-secondary">
              Our service is not intended for children under 13. We do not knowingly collect personal information from children under 13. If you believe we have collected such information, please contact us immediately.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">8. International Data Transfers</h2>
            <p className="text-brand-text-secondary">
              Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your data in accordance with this Privacy Policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">9. Changes to This Policy</h2>
            <p className="text-brand-text-secondary">
              We may update this Privacy Policy periodically. We will notify you of any material changes by posting the new policy on this page and updating the effective date.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">10. Contact Us</h2>
            <div className="bg-brand-bg p-4 rounded-lg">
              <p className="text-brand-text-secondary mb-2">
                If you have questions about this Privacy Policy or our data practices, contact us:
              </p>
              <div className="space-y-1 text-brand-text-secondary">
                <p><strong>Email:</strong> nitishkumarsingh1@gmail.com</p>
                <p><strong>Company:</strong> TestSeries</p>
                <p><strong>Address:</strong> Ground Floor, VIM-65, Phase-VII, Rangeswar Nagar, Sailashree Vihar, Patia, Bhubaneswar, Odisha 751021</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};